/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Department_Overview_TabInputs */

const en_department_overview_tab = /** @type {(inputs: Department_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const nl_department_overview_tab = /** @type {(inputs: Department_Overview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overzicht`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Department_Overview_TabInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const department_overview_tab = /** @type {((inputs?: Department_Overview_TabInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Department_Overview_TabInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_department_overview_tab(inputs)
	return en_department_overview_tab(inputs)
});